import LinkIcon from "@heroicons/react/24/outline/LinkIcon";
import ShareIcon from "@heroicons/react/24/outline/ShareIcon";
import InformationCircleIcon from "@heroicons/react/24/solid/InformationCircleIcon";
import { ButtonBase, Tooltip, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import { styled as styling } from "@mui/material/styles";
import Color from "../../../assets/colors";

export const NavigationWrapper = styling("section")((props) => ({
  position: "sticky",
  top: "64px",

  background: Color.white,

  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  top: "64px",
  marginTop: "0",
  background: Color.white,

  width: "100%",

  zIndex: "15",
  padding: "30px 0",

  "@media (max-width: 1279px)": {
    top: "52px",
    padding: "1rem",
  },

  "@media (max-width: 640px)": {
    flexDirection: "column",
    gap: "1rem",
  },
}));

export const CompanyDetailWrapper = styling("div")((props) => ({
  display: props.$showDiv ? "flex" : "none",
  flexDirection: "column",
  gap: "0.5rem",
  // justifyContent: props.isTablet ? "space-between" : "flex-start",
  // margin: "2.5px 0",
  // maxWidth: "48rem",
  // width: "100%",

  "@media (max-width: 1279px)": {
    gap: "0",
    maxWidth: "40svw",
    width: "fit-contet",
  },

  "@media (max-width: 640px)": {
    maxWidth: "68svw",
  },
}));

export const CompanyName = styling("h1")({
  fontSize: "1.5625rem",
  fontWeight: "700",
  lineHeight: "2rem",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
  overflow: "hidden",
  margin: "0",

  "@media (max-width: 1280px)": {
    display: "-webkit-box",
    WebkitLineClamp: "2",
    WebkitBoxOrient: "vertical",
    overflowWrap: "anywhere",
    wordBreak: "break-word",
    whiteSpace: "wrap",
  },

  "@media (max-width: 640px)": {
    fontSize: "1.0625rem",
    lineHeight: "1.25rem",
    display: "-webkit-box",
    WebkitLineClamp: "3",
    WebkitBoxOrient: "vertical",
    overflowWrap: "anywhere",
    wordBreak: "break-word",
    whiteSpace: "wrap",
  },
});

export const TabsContainer = styling(Box)({
  display: "flex",
  alignItems: "center",
  gap: "0.25rem",

  borderRadius: "0.375rem",
  boxSizing: "border-box",
  border: "0.5px solid var(--text-light-theme-disabled, rgba(0, 0, 0, 0.38))",
  backgroundColor: Color.backgroundGrey,

  height: "3rem",
  width: "36.5rem",

  "@media (max-width: 1280px)": {
    height: "2.25rem",
    width: "24.5rem",
  },

  "@media (max-width: 640px)": {
    height: "2.5rem",
    width: "100%",
  },
});

export const TabStyled = styling(Box)((props) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",

  color: "rgba(0, 0, 0, 0.38)",
  textTransform: "capitalize",
  fontFamily: "Karla",
  fontSize: "0.875rem",
  fontWeight: "500",
  letterSpacing: "0.00938rem",
  transition: "all 0.15s ease-in-out",
  height: "100%",
  width: "100%",

  "@media (min-width: 1280px)": {
    "&:hover": {
      cursor: "pointer",
      color: "rgba(0, 0, 0, 0.87)",
      borderRadius: "0.25rem",
    },
  },

  "@media (max-width: 1280px)": {
    fontSize: "0.625rem",
  },

  "@media (max-width: 1280px)": {
    margin: "0",
    width: "100%",
    height: "100%",
    fontSize: "0.625rem",
  },

  ...(props?.selected && {
    color: Color.black,
    backgroundColor: Color.white,
    borderRadius: "0.375rem",
    margin: "1rem 0.125rem",
    height: "75%",
  }),
}));

export const NoBoldStyled = styling("span")({
  fontWeight: "500",
  margin: "0 0 0 0.2rem",
});

const sharedButtonStyles = {
  fontSize: "1rem",
  fontWeight: "700",
  fontFamily: "inter",

  borderRadius: "32rem",
  transition: "all 0.15s ease-in-out",

  whiteSpace: "nowrap",
  height: "3rem",
};

export const FilledButton = styling(ButtonBase)({
  ...sharedButtonStyles,
  color: Color.white,
  backgroundColor: Color.hiredlyPurple,
  padding: "0 1.5rem",
  minWidth: 0,

  "@media (min-width: 1280px)": {
    "&:hover": {
      backgroundColor: Color.darkPurple,
    },
  },

  "@media (max-width: 1280px)": {
    fontSize: "0.875rem",
    height: "2.25rem",
  },

  "@media (max-width: 640px)": {
    width: "100%",
    minWidth: "fit-content",
  },

  "@media (max-width: 363px)": {
    padding: "0px 6px",
  },
});

export const OutlineButton = styling(ButtonBase)({
  ...sharedButtonStyles,
  border: `2px solid ${Color.black}`,
  color: Color.black,
  padding: "0 2.5rem",
  width: "7.5rem",

  "@media (min-width: 1280px)": {
    "&:hover": {
      color: Color.black,
      backgroundColor: Color.lightGrey,
    },
  },

  "@media (max-width: 1280px)": {
    fontSize: "0.875rem",
    height: "2.25rem",
  },

  "@media (max-width: 640px)": {
    width: "100%",
    minWidth: "fit-content",
  },
  "@media (max-width: 363px)": {
    padding: "0px 10px",
  },
});

export const ShareButton = styling(ButtonBase)({
  ...sharedButtonStyles,
  border: `2px solid ${Color.black}`,
  width: "3rem",

  "@media (min-width: 1280px)": {
    "&:hover": {
      color: Color.black,
      backgroundColor: Color.lightGrey,
    },
  },

  "@media (max-width: 1280px)": {
    height: "2.25rem",
    width: "2.25rem",
  },
});

export const LinkIconStyled = styling(LinkIcon)({
  width: "16px",
  height: "16px",
  color: Color.white,
});

export const ShareIconStyled = styling(ShareIcon)({
  width: "24px",
  height: "24px",
  margin: "0 0.125rem 0 0",

  "@media (max-width: 1280px)": {
    width: "18px",
    height: "18px",
  },
});

export const ShareButtonsContainer = styling(Box)({
  position: "absolute",
  right: "60px",
  top: "38px",
  zIndex: "11",

  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "1.5rem",

  background: "#dcdcdc",
  borderRadius: "1.875rem",
  padding: "0.55rem 1.25rem 0.3rem",

  transition: "all 0.1s ease-in-out",

  "@media (max-width: 1280px)": {
    right: "40px",
    top: "40px",
    padding: "0.25rem 0.5rem 0",
  },

  "@media (max-width: 640px)": {
    right: "58px",
    top: "102px",
    padding: "0.25rem 0.35rem 0",
  },
});

export const ClipboardContainer = styling("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "10rem",
  background: Color.darkGrey,
  cursor: "pointer",
  marginBottom: "0.23rem",
  width: "1.9375rem",
  height: "1.9375rem",
});

export const InfoCirleFilledStyled = styling(InformationCircleIcon)({
  margin: "2px",
  width: "10px",
  height: "10px",
});

export const StyledTooltip = styling(Tooltip)({
  display: "flex",
  padding: "2px 8px",
  justifyContent: "center",
  gap: "4px",
  alignItems: "center",
  borderRadius: "50px",
  background: "rgba(242, 175, 41, 0.30)",
  height: "fit-content",
  width: "fit-content",
});

export const StyledTooltipText = styling(Typography)({
  color: "rgba(0, 0, 0, 0.87)",
  fontFamily: "Inter",
  fontSize: "10px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "20px",
  letterSpacing: "1.5px",
  textTransform: "uppercase",

  textWrap: "nowrap",
});

export const TooltipInfoText = styling(Typography)({
  alignSelf: "stretch",
  color: "#000000DE",
  fontFamily: "Inter",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "20px",
});
